var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0241 25.9842C32.3347 34.2925 34.22 24.6807 39.5114 29.9684C44.6128 35.0683 47.5447 36.0901 41.0814 42.5515C40.2718 43.2022 35.128 51.0298 17.0509 32.9577C-1.02841 14.8834 6.79464 9.7343 7.44545 8.92494C13.9244 2.44555 14.9286 5.39459 20.0299 10.4945C25.3213 15.7844 15.7135 17.6759 24.0241 25.9842Z",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactus);
export default __webpack_public_path__ + "static/media/contactus.67e7c7cd6b9758b82c9e92f63acb9310.svg";
export { ForwardRef as ReactComponent };